import {
  Employee,
  Merchant,
  Store,
  StoreProduct,
} from '@bofrak-backend/shared';
import { atom } from 'recoil';
import { localPersistEffect } from './atom-effects';
import {
  displayCurrencyEffect,
  storeDisplayCurrencyEffect,
} from '@bofrak-backend/shared-ui';

export const merchantAtom = atom<Merchant | null>({
  key: 'posMerchantAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect, displayCurrencyEffect],
});

export const selectedStoreAtom = atom<Store | null>({
  key: 'posSelectedStoreAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect, storeDisplayCurrencyEffect],
});

export const adminAtom = atom<Employee | null>({
  key: 'posAdminAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect],
});

/** Encrypted token for refresh persistence */
export const liteAuthTokenAtom = atom<string | null>({
  key: 'posLiteAuthTokenAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect],
});

/**
 * Decrypted Cognito access token used to authenticate API calls in lite mode.
 * Kept in-memory only (not persisted) — the encrypted token in
 * liteAuthTokenAtom is the persisted credential.
 */
export const accessTokenAtom = atom<string | undefined>({
  key: 'posLiteAccessTokenAtom',
  default: '',
});

export const storeProductsAtom = atom<StoreProduct[]>({
  key: 'posStoreProductsAtom',
  default: [],
});

export const searchResultsAtom = atom<StoreProduct[]>({
  key: 'posSearchResultsAtom',
  default: [],
});
